<template>
  <el-dialog
            v-if="visibles"
            :visible.sync="visibles"
            :before-close="closeDialog"
            :close-on-click-modal="false"
            :lock-scroll="false"
            :destroy-on-close="true"
            :show-close="false"
            top="2vh"
            width="70%"
            center
    >
        <dialog-header
                slot="title"
                :title="!isEdit?$t('baseData.terminalConfig.createAndUpdate.create'):$t('baseData.terminalConfig.createAndUpdate.update')"
                :icon="!isEdit? 'icon-dialog-add':'icon-dialog-update'"
                @close="closeDialog"
        />
        <vue-linetitle>
            <el-form
                    ref="formLeft"
                    :model="formInfo"
                    :label-position="'right'"
                    label-width="auto"
            >
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item required :show-message="false" :label="$t('public.obdCode')+'：'" prop="barCode">
                        <div v-if="isEdit">
                            <el-input :readonly="true" v-model="formInfo.barCode"  clearable :placeholder="$t('baseData.terminalConfig.createAndUpdate.binding')" />
                        </div>
                        <div v-else>
                            <el-input @click.native="selectTerminal" :readonly="true" v-model="formInfo.barCode"  clearable :placeholder="$t('baseData.terminalConfig.createAndUpdate.binding')" />
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item required :show-message="false" :label="$t('baseData.terminalConfig.configName')+'：'" prop="configId">
                        <el-select v-model="formInfo.configId"  clearable :placeholder="$t('baseData.terminalConfig.configName')">
                            <el-option v-for="cn in configNameIds" :label="cn.configName" :value="cn.id" :key="cn.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item required :show-message="false" :label="$t('baseData.terminalConfig.responseVid')+'：'" prop="responseVid">
                        <el-input v-model="formInfo.responseVid"  clearable :placeholder="$t('baseData.terminalConfig.responseVid')" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item  required :show-message="false" :label="$t('carManagement.vinno')+'：'" prop="responseVin">
                        <el-input v-model="formInfo.responseVin"  clearable :placeholder="$t('carManagement.vinno')" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item required :show-message="false" :label="$t('baseData.terminalConfig.responseDisplacement')+'：'" prop="responseDisplacement">
                        <el-input v-model="formInfo.responseDisplacement"  clearable :placeholder="$t('baseData.terminalConfig.responseDisplacement')" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item  required :show-message="false" :label="$t('baseData.terminalConfig.responseInit')+'：'" prop="responseInit">
                        <el-select   v-model.number="formInfo.responseInit"  clearable :placeholder="$t('baseData.terminalConfig.responseInit')">
                            <el-option v-for="item in responseInits" :label="item.label" :value='item.value' :key="item.value" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item  required :show-message="false" :label="$t('baseData.terminalConfig.responseYear')+'：'" prop="responseYear">
                        <el-date-picker v-model="formInfo.responseYear"  value-format="yyyy" type="year" :placeholder="$t('baseData.terminalConfig.responseYear')"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
          </el-form>
        </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button v-waves class="dialog-cancel" type="primary" @click="handleCancel">{{ $t('public.cancel') }}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{ $t('public.define') }}</el-button>
    </span>
    <look-nine-five-obd-dialog 
        :visibles.sync="lookVisible" 
        :is-edit="isEdit"
        :data="formInfo"
        @add-complete="addComplete"
        @setTerminalId="setTerminalId"
    >
    </look-nine-five-obd-dialog>
  </el-dialog>
</template>

<script>
    // 混入
    import { partialForm } from '@/mixins/partialForm'
    //request
    import {updateTerminalConfig,getNineFiveOBD,createTerminalConfig} from '@/api/obdDevice/obdConfig'
    import { getResponseList } from '@/api/obdDevice/nineFiveResponse'
    //组件
    import lookNineFiveObdDialog from "./lookNineFiveOBDDialog"
    export default {
        name: "addUpdateDialog",
        mixins: [partialForm],
        components: { lookNineFiveObdDialog },
        props: {
            visibles: {
                type: Boolean,
                default: false
            },
            isEdit: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return{
                formInfo: {  },
                configNameIds:[ ],
                lookVisible: false,
                responseInits:[
                    {label:'是',value:0},
                    {label:'否',value:1}
                ],
                terminal:{ }
            }
        },
        watch: {
            visibles(el) {
                if(el){
                    this.formInfo = {barCode: ''}
                    this.listConfigNameIds()
                    if(this.isEdit){
                        this.listLoad()
                    }
                }
            }
        },
        methods:{
            //获取编辑所选OBD信息
            listLoad(){
                getNineFiveOBD(this.data.terminalId).then(({data})=>{
                    data.data.responseYear = " "+data.data.responseYear
                    this.data.responseYear = " "+this.data.responseYear
                    this.formInfo = {...data.data,...this.data}
                })
            },
            //加载下拉栏
            listConfigNameIds(){
                const arg = {
                    pageSize:10,
                    pageNum:1
                }
                getResponseList(arg).then(({data}) =>{
                    if(data.code === 0){
                        this.configNameIds=data.data
                    }
                })
            },
            // 关闭
            closeDialog() {
                this.formInfo = { }
                this.$emit('update:visibles', false)
            },
            // 取消
            handleCancel() {
                this.closeDialog()
            },
            //添加成功
            addComplete(){
                this.$emit('add-complete')
                this.closeDialog()
            },
            //进入子组件
            selectTerminal(){
                this.lookVisible = true
            },
            handleSubmit(){
                const formCheckLeft = this.checkForm({
                    formName: 'formLeft',
                    formList: [
                        'configId','responseInit','terminalCode','barCode'
                    ]
                })
                if (!formCheckLeft) {
                    return
                }
                if (!this.isEdit) {
                    const postData = {...this.terminal,...this.formInfo,}
                    this._createTerminalConfig(postData)
                } else {
                    const postData = {...this.formInfo}
                    this._updateTerminalCode(postData)
                }
            },
            //子组件向父组件传递所选OBD设备
            setTerminalId(data){
                this.terminal = {...data}
                this.formInfo.barCode = data.barCode
            },
            // 新增
            _createTerminalConfig(postData) {
                //注意参数的顺序
                // postData = {...this.currentRow,...this.data} 
                createTerminalConfig(postData).then(({ data }) => {
                    if (data.code === 0) {
                        this.$message.success({
                            message: this.$t('public.createSuccess'),
                            duration: 2 * 1000
                        })
                        this.$emit('add-complete')
                        this.closeDialog()
                    }
                }).catch(()=>{})
            },
            _updateTerminalCode(postData) {
                updateTerminalConfig(this.data.terminalId,postData).then(({ data }) => {
                    if (data.code === 0) {
                        this.$message.success({
                            message:  this.$t('public.updateSuccess'),
                            duration: 2 * 1000
                        })
                        this.formInfo={ }
                        this.closeDialog()
                        this.$emit('update-complete')
                    }
                }).catch(()=>{})
            }
        }
    }
</script>

<style scoped>

</style>